import axios from 'axios';
import { defineComponent } from 'vue';
import AccountService from '@/account/account.service';
import { emitter } from '@/shared/event-bus';

export default defineComponent({
  inject: ['accountService'],
  data() {
    return {
      authenticationError: null,
      login: null,
      password: null,
      rememberMe: null,
    };
  },
  watch: {
    $route() {
      emitter.emit('hide-login');
    },
  },
  methods: {
    doLogin(): void {
      const data = { username: this.login, password: this.password, rememberMe: this.rememberMe };
      axios
        .post('api/authenticate', data)
        .then(result => {
          const bearerToken = result.headers.authorization;
          if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
            const jwt = bearerToken.slice(7, bearerToken.length);
            if (this.rememberMe) {
              localStorage.setItem('jhi-authenticationToken', jwt);
              sessionStorage.removeItem('jhi-authenticationToken');
            } else {
              sessionStorage.setItem('jhi-authenticationToken', jwt);
              localStorage.removeItem('jhi-authenticationToken');
            }
          }
          this.authenticationError = false;
          emitter.emit('hide-login');
          (this.accountService as () => AccountService)().retrieveAccount();
        })
        .catch(() => {
          this.authenticationError = true;
        });
    },
  },
});
